import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import exact from 'prop-types-exact'
import { itemShareIntent } from '../item/itemsActions'

export default class ShareButtonFacebook extends PureComponent {
  render() {
    const { link, facebookAppId } = this.props
    const href = 'https://www.facebook.com/dialog/share?app_id=' + facebookAppId + '&display=page&locale=fi_FI&href=' + link
    const title = 'Jaa uutinen Facebookissa'

    // https://fontawesome.com/v5/icons/facebook-f?f=brands&s=solid
    return (
      <a
        className='share-button share-button--facebook'
        target='_blank'
        rel='noopener noreferrer'
        href={ href }
        title={ title }
        onClick={ this.handleClick }
      >
        <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 320 512' width='15' height='15'>
          <path d='M279.1 288l14.2-92.7h-88.9v-60.1c0-25.4 12.4-50.1 52.2-50.1h40.4V6.3S260.4 0 225.4 0c-73.2 0-121.1 44.4-121.1 124.7v70.6H22.9V288h81.4v224h100.2V288z' />
        </svg>
      </a>
    )
  }

  handleClick = () => {
    const { itemId, dispatch } = this.props
    dispatch(itemShareIntent(itemId, 'facebook'))
  }
}

ShareButtonFacebook.propTypes = exact({
  link: PropTypes.string.isRequired,
  facebookAppId: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
  itemId: PropTypes.string.isRequired,
})
